<template>
  <div class="container-yard-home">
    <van-notice-bar left-icon="volume-o" :scrollable="false">
      <van-swipe vertical class="notice-swipe" :autoplay="10000" :show-indicators="false">
        <van-swipe-item>加油1000元免费送1次装箱单预录，以此类推！</van-swipe-item>
      </van-swipe>
    </van-notice-bar>
    <h2 style="color: #d81e06">千里码装箱单预录</h2>
    <!--<h2 style="color: #d81e06">元升落箱</h2>-->
    <van-row type="flex" justify="center">
      <van-col span="20">
        <van-button plain to="/pre-record/input">装箱单预录</van-button>
      </van-col>
    </van-row>

    <p></p>
    <van-cell-group>
      <!--<van-cell title="可用免费预录次数" :value="this.point" @click="goWalletLog()" is-link/>-->
      <van-cell title="可用免费预录次数" :value="this.point"/>
    </van-cell-group>
    <tabbar :selected="selected"></tabbar>
  </div>
</template>

<script>
import tabbar from '@/components/tabbar'
import common from "../../common";
import querystring from "querystring";

export default {
  components: {tabbar},
  data() {
    return {
      selected: "productlist",
      point: 0,
    };
  },
  methods: {
    getWallet() {
      let querystring = require('querystring');
      let token = JSON.parse(common.getlocalStorage("userInfo")).token;
      this.$api.post("/wx/prerecord/freeInfo",
          querystring.stringify({
            mobile: localStorage.getItem("tel"),
            token: token,
          })
      ).then(data => {
        if (data.data.status == 1) {
          this.point = data.data.data.freeCount;
        } else {

        }
      }).catch(err => {
        console.log(err);
      });
    },
    goWalletLog() {
      this.$router.push("/wallet_log");
    },
    getBillList() {

    },
    //获取用户openid
    getOpenid() {
      let url = window.location.href;
      let querystring = require("querystring");
      this.$api.post("/wx/getUrl",
          querystring.stringify({
            url
          })
      ).then(({data}) => {
        window.location.href = data;
      });
    },
  },
  mounted() {
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    //判断地址栏上是否存在openid;
    let ifopenid = window.location.href.indexOf("openid") != -1;
    //判断是否已经登录
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.mobile = JSON.parse(common.getlocalStorage("userInfo")).mobile;
      this.login_bol = true;
      let token = JSON.parse(common.getlocalStorage("userInfo")).token;
    } else if (ifcookietoken) {
      this.login_bol = true;
      let token = common.getCookie("token");
      this.mobile = common.getCookie("mobile");
    } else if (ifopenid) {
      let openid = window.location.href.split("openid=")[1].split("#/")[0];
      this.ifQueryBinding(openid);
    } else {
      this.getOpenid();
    }
    this.getWallet();
  }
}
</script>

<style lang="less" scoped>
.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.container-yard-home .van-cell {
  text-align: left;
}

.van-row {
  margin: 1rem;
}

.van-button {
  height: 3rem;
  width: 6rem;
  font-size: 0.7rem;
}
</style>


// WEBPACK FOOTER //
// src/components/pre-record/home.vue